interface SSEErrorPayload {
	error_type?: string;
	message?: string;
	detail?: string;
}

export const extractSSEErrorMessage = (event: Event | MessageEvent): string => {
	const messageEvent = event as MessageEvent;

	if (!messageEvent.data) {
		return 'Connection interrupted or server closed stream';
	}

	try {
		const rawData: unknown = JSON.parse(messageEvent.data);
		if (typeof rawData === 'object' && rawData !== null) {
			const data = rawData as SSEErrorPayload;
			if (data.error_type) {
				return data.error_type;
			}
			if (data.message) {
				return data.message;
			}
			if (data.detail) {
				return data.detail;
			}
		}

		return 'Unknown server error';
	} catch (e) {
		// biome-ignore lint/suspicious/noConsole: SSE payload parse error reporting until Sentry SDK is wired up
		console.warn('Error parsing SSE payload:', e);
		return String(messageEvent.data);
	}
};
